import { createSelector } from 'reselect';

import type { IRootState } from '../types';

import { selectors } from './adapter';

export const selectMediaItems = createSelector(
  (state: IRootState) => state.media,
  (state) => ({
    items: selectors.selectAll(state),
    loading: state.loading,
    error: state.error,
  }),
);
